import { useCallback, useState } from 'react';
import { captureException } from '@sentry/react';
import { useLocation, useNavigate } from 'react-router-dom';

import { authorizedAxiosInstance } from '@/clients';
import { toast } from '@/shared/components/toasts/PlatformToast';
import { useUserStore } from '@/stores';
import { useBillingStore } from '@/stores/database/aliases/billing';
import { getInternalPathFromLocation, sanitizeRedirect } from '@/utilities';

export const useCheckout = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const { updateSelectedUserLocal } = useUserStore();
    const refreshBillingSnapshot = useBillingStore((state) => state.refreshSnapshot);

    // try {
    const createCheckout = useCallback(
        async (payload: any) => {
            try {
                setLoading(true);

                const fallbackRedirect =
                    payload?.redirect === undefined && !payload?.isOnboarding
                        ? sanitizeRedirect(
                              getInternalPathFromLocation(location, { stripRedirect: true, stripStripeStatus: true }),
                          )
                        : '';
                const redirect = sanitizeRedirect(payload?.redirect) || fallbackRedirect;

                const res = await authorizedAxiosInstance.post(
                    '/api/billing/checkout-session',
                    {
                        ...payload,
                        redirect,
                    },
                    {
                        // headers: {
                        //     'Idempotency-Key': nanoId(24),
                        // },
                    },
                );

                if (res.data.user) {
                    updateSelectedUserLocal(res.data.user);
                    await refreshBillingSnapshot();
                }

                const checkoutURL = res.data.url;

                const nextURL = new URL(checkoutURL, window.location.origin);

                if (nextURL.origin === window.location.origin) {
                    navigate(`${nextURL.pathname}${nextURL.search}`);

                    return res.data;
                }

                window.location.assign(checkoutURL);

                console.log(res.data);

                return res.data;
            } catch (err) {
                captureException(err);

                toast.error('Unable to start checkout. Please try again.');

                throw err;
            } finally {
                setLoading(false);
            }
        },
        [location, navigate, refreshBillingSnapshot, updateSelectedUserLocal],
    );

    return { createCheckout, loading };
    // } catch (error) {
    //     captureException(error);
    // } finally {
    //     setLoading(false);
    // }
};
